import { BackIcon } from '../icons';
import { DotsIcon, PauseIcon, PlayIcon } from './icons';

export function formatTime(ms: number): string {
  const total = Math.floor(ms / 1000);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const mm = h > 0 ? String(m).padStart(2, '0') : String(m);
  return `${h > 0 ? `${h}:` : ''}${mm}:${String(s).padStart(2, '0')}`;
}

export function SolveHeader(props: {
  title: string;
  subtitle: string;
  elapsedMs: number;
  paused: boolean;
  hideTimer: boolean;
  finished: boolean;
  menuOpen: boolean;
  onBack: () => void;
  onTimer: () => void;
  onMenu: () => void;
}) {
  return (
    <header className="flex min-h-[52px] shrink-0 items-center gap-1 px-1.5">
      <button
        type="button"
        aria-label="Back"
        onClick={props.onBack}
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-btn border-0 bg-transparent p-0 text-ink"
      >
        <BackIcon />
      </button>
      <div className="flex min-w-0 flex-1 flex-col gap-px">
        <span className="truncate text-[16px] font-semibold">{props.title}</span>
        {props.subtitle && (
          <span className="truncate text-[12px] text-muted">{props.subtitle}</span>
        )}
      </div>
      <button
        type="button"
        onClick={props.onTimer}
        disabled={props.finished}
        aria-label={props.paused ? 'Resume' : 'Pause'}
        className="flex h-9 shrink-0 items-center gap-1.5 rounded-full border border-line bg-surface px-3 text-[14px] font-semibold text-ink tabular-nums"
      >
        {props.paused ? <PlayIcon /> : <PauseIcon />}
        {!props.hideTimer && <span>{formatTime(props.elapsedMs)}</span>}
      </button>
      <button
        type="button"
        aria-label="Menu: nudge, check, restart, rules, settings"
        aria-expanded={props.menuOpen}
        onClick={props.onMenu}
        className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-btn border-0 p-0 text-ink ${props.menuOpen ? 'bg-[#E2DDD2]' : 'bg-transparent'}`}
      >
        <DotsIcon />
      </button>
    </header>
  );
}
